module.exports = __webpack_public_path__ + "img/zizhi4.de7c48a1.jpg";